<nav class="navbar fixed-top navbar-expand-md navbar-ls navbar-dark bg-ls-dark">
  <a class="navbar-brand" routerLink="/admin" ngbTooltip="Retour à l'accueil" placement="bottom">
    <img src="assets/portal.png" title="Revenir à l'accueil de l'application" alt="Logo de l'application">
    Administration du Portail client
  </a>
  <div class="collapse navbar-collapse justify-content-end">
    <ul class="navbar-nav">
      <li class="nav-item" ngbDropdown placement="bottom-end">
        <a class="nav-link" ngbDropdownToggle [routerLink]="[]" id="navbarDropdown" role="button" data-toggle="dropdown"
           aria-haspopup="true" aria-expanded="false">
          {{ name }}
        </a>
        <div ngbDropdownMenu class="dropdown-menu-end" aria-labelledby="navbarDropdown">
          <a ngbDropdownItem
             target="_blank"
             href="https://gitlab.libriciel.fr/libriciel/projets-internes/outils-internes/produits/portailclient/documentations/documentations-fonctionnelles/pc-doc_manuel_administration_operateur_LS">
            <fa-icon icon="book"></fa-icon>
            <span>Documentation</span>
          </a>
          <div class="dropdown-divider"></div>
          <a ngbDropdownItem [routerLink]="[]" (click)="logout()">
            <fa-icon icon="sign-out-alt"></fa-icon>
            <span>Se déconnecter</span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</nav>

